/**
 * Role IDs for RBAC (Role-Based Access Control)
 */
export enum RbacRoleId {
  SUPER_ADMIN = "super_admin",
  ADMIN_MED_ONC = "admin_med_onc",
  STANDARD_MED_ONC = "standard_med_onc",
}

/**
 * Type for assignable roles (excludes super_admin)
 */
export type AssignableRoleId =
  | RbacRoleId.ADMIN_MED_ONC
  | RbacRoleId.STANDARD_MED_ONC;
